import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui class helper: clsx + tailwind-merge (later classes win over earlier conflicting ones). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
